import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import Badge from '../Badge';
import type { BadgePropsWithoutTooltip } from '../../types';

const NewBadge = ({ dataTestId }: BadgePropsWithoutTooltip) => (
  <Badge backgroundColor="pink_900" dataTestId={dataTestId}>
    <I18n k="badges.new_badge.text" />
  </Badge>
);

NewBadge.displayName = 'NewBadge';

export default NewBadge;
